export const AUTH_HINT_STORAGE_KEY = "upsider_nav_auth";
export const NAV_AUTH_CLASS = "nav-auth";
export const NAV_SIGNED_OUT_VARIANT_CLASS = "[.nav-auth_&]:hidden";
export const NAV_SIGNED_IN_VARIANT_CLASS = "hidden [.nav-auth_&]:block";

export const NAV_AUTH_HEAD_SCRIPT = `try{if(localStorage.getItem('${AUTH_HINT_STORAGE_KEY}')==='1')document.documentElement.classList.add('${NAV_AUTH_CLASS}')}catch(e){}`;

export function rememberAuthHint(signedIn: boolean): void {
  document.documentElement.classList.toggle(NAV_AUTH_CLASS, signedIn);
  try {
    if (signedIn) localStorage.setItem(AUTH_HINT_STORAGE_KEY, "1");
    else localStorage.removeItem(AUTH_HINT_STORAGE_KEY);
  } catch {
  }
}
